var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',_vm._g(_vm._b({class:[
    'ui-button',
    {
      tr_garay: _vm.tr_garay,
    } ],attrs:{"type":"primary","block":""}},'a-button',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners),[(!_vm.awaitingResponse)?_vm._t("default"):_c('a-spin',[_c('a-icon',{staticClass:"ui-spin",attrs:{"slot":"indicator","type":"loading","spin":""},slot:"indicator"})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }